import Vue from 'vue'
import axios from 'axios'
import Plugin from './plugin'

Vue.use(Plugin, axios)



// WEBPACK FOOTER //
// ./src/configs/axios/index.js